import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import type { Props } from 'nextjs/getServerSideProps';
import PageNextJs from 'nextjs/PageNextJs';

const Products = dynamic(() => import('ui/pages/Products'), { ssr: false });

const Page: NextPage<Props> = () => {

  return (
    <PageNextJs pathname="/products">
      <Products/>
    </PageNextJs>
  );
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps';
